import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_DRAWINGS_REFRESH: createSagaAction('JOB_DRAWINGS_REFRESH'),
  JOB_DRAWING_CREATE: createSagaAction('JOB_DRAWING_CREATE'),
  JOB_DRAWING_UPDATE: createSagaAction('JOB_DRAWING_UPDATE'),
  JOB_DRAWING_DELETE: createSagaAction('JOB_DRAWING_DELETE'),

  UPLOAD_DRAWING_ATTACHMENT: createSagaAction('UPLOAD_DRAWING_ATTACHMENT'),
  GET_DRAWING_ATTACHMENTS: createSagaAction('GET_DRAWING_ATTACHMENTS'),
  UPDATE_DRAWING_ATTACHMENT_DESCRIPTION: createSagaAction('UPDATE_DRAWING_ATTACHMENT_DESCRIPTION'),
  DELETE_DRAWING_ATTACHMENT: createSagaAction('DELETE_DRAWING_ATTACHMENT')
}

// Action Creators
export const actions = {
  jobDrawingsRefresh: ({ jobId }) => ({
    type: constants.JOB_DRAWINGS_REFRESH.ACTION,
    jobId
  }),

  createJobDrawing: ({ jobId, drawingId, userId, description, drawingType, drawingStatus }) => ({
    type: constants.JOB_DRAWING_CREATE.ACTION,
    jobId,
    drawingId,
    userId,
    description,
    drawingType,
    drawingStatus
  }),

  updateJobDrawing: ({ jobId, drawingId, userId, description, drawingType, drawingStatus }) => ({
    type: constants.JOB_DRAWING_UPDATE.ACTION,
    jobId,
    drawingId,
    userId,
    description,
    drawingType,
    drawingStatus
  }),

  deleteJobDrawing: ({ drawingId, jobId }) => ({
    type: constants.JOB_DRAWING_DELETE.ACTION,
    jobId,
    drawingId
  }),

  // Attachment actions
  uploadAttachment: ({ formData, drawingId }) => ({
    type: constants.UPLOAD_DRAWING_ATTACHMENT.ACTION,
    formData,
    drawingId
  }),

  getDrawingAttachments: ({ drawingId }) => ({
    type: constants.GET_DRAWING_ATTACHMENTS.ACTION,
    drawingId
  }),

  updateAttachmentDescription: ({ attachmentId, drawingId, description, status, userId }) => ({
    type: constants.UPDATE_DRAWING_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    drawingId,
    description,
    status,
    userId
  }),

  deleteAttachment: ({ attachmentId, drawingId }) => ({
    type: constants.DELETE_DRAWING_ATTACHMENT.ACTION,
    attachmentId,
    drawingId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_DRAWINGS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_DRAWINGS_REFRESH.SUCCESS:
      return {
        ...state,
        jobDrawings: action.payload
      }
    case constants.JOB_DRAWINGS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_DRAWING_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_DRAWING_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_DRAWING_DELETE.SUCCESS:
      return {
        ...state
      }

    case constants.UPLOAD_DRAWING_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_DRAWING_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_DRAWING_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_DRAWING_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobDrawingAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_DRAWING_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_DRAWING_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_DRAWING_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobDrawingActions.js